import { MappedClass, MappedProperty } from '@h5s/util-object';
import { CashRegisterType } from './cash-register-type';
import { CashRegisterOrderBy } from './cash-register-order-by';

@MappedClass()
export class QueryCashRegister {
  @MappedProperty()
  id?: number;

  @MappedProperty()
  ownerCorporateDataId?: number;

  @MappedProperty()
  description?: string;

  @MappedProperty()
  descriptionStart?: string;

  @MappedProperty()
  cashRegisterType?: CashRegisterType;

  @MappedProperty()
  address?: string;

  @MappedProperty()
  port?: string;

  @MappedProperty()
  username?: string;

  @MappedProperty()
  localAddress?: string;

  @MappedProperty()
  doubleCopy?: boolean;

  @MappedProperty()
  ascending?: boolean = true;

  @MappedProperty()
  orderBy?: CashRegisterOrderBy;
}
